/**
 * Toutes les routes de l'application.
 * Utiliser ces constantes partout — jamais de strings en dur.
 */
export const ROUTES = {
  // Onboarding (avant auth)
  LANGUAGE:       '/language',

  // Publiques
  AUTH:           '/auth',
  REGISTER:       '/register',
  REGISTER_TYPE:  '/register/:type',
  TERMS:          '/terms',

  // Semi-authentifiée (connecté mais email non vérifié)
  EMAIL_VERIFY:   '/email-verify',

  // Privées (authentifiées + email vérifié)
  HOME:           '/home',
  MESSAGES:       '/messages',
  CHAT:           '/messages/:conversationId',
  NEW_POST:       '/new-post',
  POST:           '/post/:id',
  EDIT_POST:      '/edit-post/:id',
  SEARCH:         '/search',
  PROFILE:        '/profile/:id',
  MY_PROFILE:     '/my-profile',
  SETTINGS:       '/settings',
  NOTIFICATIONS:  '/notifications',
} as const;

/**
 * Helpers pour les routes paramétrées
 */
export const buildRoute = {
  registerType:  (type: string)  => `/register/${type}`,
  post:          (id: string)    => `/post/${id}`,
  editPost:      (id: string)    => `/edit-post/${id}`,
  profile:       (id: string)    => `/profile/${id}`,
  chat:          (id: string)    => `/messages/${id}`,
} as const;
